<template>
  <div class="pt-4" :style="{ height: `${appHeight - 48 - 33}px` }">
    <div
      data-scroll-lock-scrollable
      class="flex overflow-x-scroll no-scrollbar mb-4 md:mb-0 px-5 xl:px-0 w-screen md:w-full items-start justify-start md:flex-wrap col-start-1 col-end-4 md:pr-[112px] gap-x-4 gap-y-2"
    >
      <div
        v-for="main in props.menu"
        :key="main.title"
        :class="
          twJoin(
            'whitespace-nowrap px-4 py-3 rounded-2xl text-black hover:opacity-50 cursor-pointer border-[1px] border-border-divider',
            activeMenu == main.title &&
              'bg-primary-tangerine !opacity-100 !text-primary-white border-primary-tangerine'
          )
        "
        @click="
          () => {
            if (activeMenu !== main.title) {
              activeMenu = main.title
              activeList = null
              activeSubList = null
            }
          }
        "
      >
        {{ main.titleMobile }}
      </div>
      <NuxtLinkLocale
        to="/blogs"
        :class="
          twJoin(
            'whitespace-nowrap px-4 py-3 rounded-2xl text-black hover:opacity-50 cursor-pointer border-[1px] border-border-divider',
            activeMenu == $t('pages.blogs.expore') &&
              'bg-primary-tangerine !opacity-100 !text-primary-white border-primary-tangerine'
          )
        "
        @click="() => emit('close')"
      >
        {{ $t('pages.blogs.expore') }}
      </NuxtLinkLocale>
    </div>
    <div
      v-if="activePage"
      data-scroll-lock-scrollable
      class="flex flex-col overflow-scroll overflow-x-visible"
      :style="{ height: `${appHeight - 48 - 33 - 48 - 32}px` }"
    >
      <div v-if="!activePage.blockItems">
        <div v-if="!activeList">
          <NuxtLinkLocale
            prefetch
            :to="activePage.url"
            class="block border-dashed border-b border-border-divider py-4 mx-5 font-medium text-primary-tangerine"
            @click="() => emit('close')"
          >
            {{ activePage.title }}
          </NuxtLinkLocale>
          <div
            v-for="menuItem in activePage?.list"
            :key="menuItem.title"
            class="border-dashed border-b last:border-none border-border-divider py-4 mx-5 font-medium cursor-pointer hover:opacity-50 fill-black flex items-center justify-between"
            @click="activeList = menuItem.title"
          >
            <div>
              {{ menuItem.title }}
            </div>
            <Icon name="chevron-right" />
          </div>
        </div>
        <div v-else>
          <div
            class="border-b px-5 border-border-divider py-4 font-medium flex items-center gap-x-4 cursor-pointer hover:opacity-50"
            @click="
              () => {
                activeList = ''
              }
            "
          >
            <Icon name="chevron-left" />
            <div>{{ activeList }}</div>
          </div>

          <div
            v-for="(list, listIndex) in activeListPage?.linkItems"
            :key="listIndex"
          >
            <div
              :class="
                twJoin(
                  'flex items-center justify-between py-4 mx-5 cursor-pointer hover:opacity-50 border-dashed border-border-divider',
                  activeSubList != list.title &&
                    listIndex !==
                      (activeListPage?.linkItems?.length || 0) - 1 &&
                    'border-b'
                )
              "
              @click="
                () => {
                  if (activeSubList == list.title) activeSubList = null
                  else activeSubList = list.title
                }
              "
            >
              <div>{{ list.title }}</div>
              <Icon v-if="activeSubList == list.title" name="minus" />
              <Icon v-if="activeSubList != list.title" name="plus" />
            </div>
            <div
              v-if="activeSubList === list.title"
              class="flex flex-col bg-gray-10 py-6 space-y-4"
            >
              <NuxtLinkLocale
                v-for="(listItem, listItemIndex) in list.items"
                :key="listItemIndex"
                prefetch
                :to="listItem.url"
                class="px-5 hover:opacity-50 flex items-center gap-x-2"
                @click="() => emit('close')"
              >
                <img
                  v-if="listItem.imageUrl"
                  alt=""
                  :src="listItem.imageUrl"
                  class="w-10 h-10 rounded-full object-cover border border-border-divider"
                />
                {{ listItem.title }}
              </NuxtLinkLocale>
              <NuxtLinkLocale
                prefetch
                :to="list.url"
                class="block text-primary-tangerine font-bold underline hover:opacity-50 px-5"
                @click="emit('close')"
              >
                {{ list.footerTitle }}
              </NuxtLinkLocale>
            </div>
          </div>
          <div v-if="activeListPage?.linkItems.length === 0">
            <div
              v-for="(cardItems, cardItemsIndex) in activeListPage?.cardItems"
              :key="cardItemsIndex"
              class="bg-gray-10 px-5 py-5"
            >
              <div class="grid grid-cols-2 gap-x-[10px] gap-y-[10px]">
                <NuxtLinkLocale
                  v-for="(card, cardIndex) in cardItems.items"
                  :key="cardIndex"
                  prefetch
                  class="w-full hover:opacity-50"
                  :to="card.url"
                  @click="emit('close')"
                >
                  <div class="relative w-full pt-[100%]">
                    <div
                      class="absolute top-0 left-0 w-full h-full bg-primary-white rounded-xl"
                    >
                      <img
                        alt=""
                        :src="card.imageUrl"
                        class="w-full h-full object-cover border border-border-divider rounded-xl"
                      />
                      <div
                        class="absolute w-6 h-6 right-0 bottom-[48px] rounded-full border-b border-border-divider -rotate-45 border-l border-l-transparent border-r border-r-transparent"
                      />
                      <div
                        class="absolute w-6 h-6 right-[48px] bottom-0 rounded-full border-b border-border-divider -rotate-45 border-l border-l-transparent border-r border-r-transparent"
                      />
                      <div
                        :class="
                          twJoin(
                            'absolute bottom-0 right-0 z-10 pt-2 pl-2 bg-gray-10 rounded-tl-lg',
                            'border-t border-l border-border-divider',
                            `after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-3 after:h-3 after:bg-[radial-gradient(circle_at_100%_100%,_transparent_12px,_#F2F2F3_12px)] after:rotate-180 after:-translate-x-[100%]`,
                            `before:content-[''] before:absolute before:right-0 before:top-0 before:w-3 before:h-3 before:bg-[radial-gradient(circle_at_100%_100%,_transparent_12px,_#F2F2F3_12px)] before:rotate-180 before:-translate-y-[100%]`
                          )
                        "
                      >
                        <div
                          class="w-10 h-10 bg-black flex items-center justify-center rounded-lg"
                        >
                          <svg
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21 1.25V15.25C21 15.8125 20.5 16.25 20 16.25C19.4375 16.25 19 15.8125 19 15.25V3.6875L2.6875 20C2.5 20.1875 2.25 20.25 2 20.25C1.6875 20.25 1.4375 20.1875 1.25 20C0.875 19.625 0.875 18.9375 1.25 18.5625L17.5625 2.25H5.9375C5.4375 2.25 4.9375 1.75 5 1.25C5 0.6875 5.4375 0.25 6 0.25H20C20.5 0.25 21 0.75 21 1.25Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="bg-gray-10 relative z-10 pt-4">
                    {{ card.title }}
                  </div></NuxtLinkLocale
                >
              </div>
              <div v-if="cardItems.footerTitle && cardItems.url" class="mt-4">
                <NuxtLinkLocale
                  prefetch
                  :to="cardItems.url"
                  class="inline text-primary-tangerine font-bold underline hover:opacity-50"
                  @click="emit('close')"
                >
                  {{ cardItems.footerTitle }}
                </NuxtLinkLocale>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="activePage?.blockItems?.items" class="pb-[68px]">
          <div class="flex flex-wrap md:flex-nowrap py-4">
            <div
              v-for="blockItem in activePage?.blockItems?.items"
              :key="blockItem.titleEn"
              class="w-full mx-5 py-4 border-dashed border-b-2 border-border-divider md:border-none last:border-none"
            >
              <NuxtLinkLocale
                prefetch
                :to="blockItem.buttonUrl"
                @click="emit('close')"
              >
                <img
                  alt=""
                  :src="blockItem.imageUrl"
                  class="xl:h-[120px] w-full object-cover rounded-lg"
                />
                <div
                  class="pb-4 mb-4 mt-4 text-xl font-medium border-dashed border-b-2 border-border-divider"
                >
                  {{
                    locale === 'en'
                      ? blockItem.titleEn
                      : blockItem.titleTh || blockItem.titleEn
                  }}
                </div>
                <div class="mb-[10px]">
                  {{
                    locale === 'en'
                      ? blockItem.descriptionEn
                      : blockItem.descriptionTh || blockItem.descriptionEn
                  }}
                </div>

                <div class="text-primary-tangerine font-bold underline">
                  {{ blockItem.buttonTitle }}
                </div>
              </NuxtLinkLocale>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-auto">
        <NuxtLinkLocale
          v-if="access_token"
          prefetch
          to="/"
          class="border-dashed border-b border-border-divider py-4 px-5 flex items-center gap-x-2 hover:opacity-50"
          @click="
            () => {
              userStore.logout()
              emit('close')
            }
          "
        >
          <Icon name="right-to-bracket" />
          <div>{{ $t('myAccount.logOut') }}</div>
        </NuxtLinkLocale>
        <NuxtLinkLocale
          v-else
          prefetch
          to="/sign-up"
          class="border-dashed border-b border-border-divider py-4 px-5 flex items-center gap-x-2 hover:opacity-50"
          @click="() => emit('close')"
        >
          <Icon name="right-to-bracket" />
          <div>Login / Sign up</div>
        </NuxtLinkLocale>
        <div class="flex items-center gap-x-2 px-5">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2.5C17.5078 2.5 22 6.99219 22 12.5C22 18.0469 17.5078 22.5 12 22.5C6.45312 22.5 2 18.0469 2 12.5C2 6.99219 6.45312 2.5 12 2.5ZM12 21.25C12.625 21.25 13.5625 20.7031 14.3828 19.0234C14.7734 18.2422 15.125 17.3047 15.3203 16.25H8.64062C8.83594 17.3047 9.1875 18.2422 9.57812 19.0234C10.3984 20.7031 11.3359 21.25 12 21.25ZM8.40625 15H15.5547C15.6719 14.2188 15.75 13.3984 15.75 12.5C15.75 11.6406 15.6719 10.8203 15.5547 10H8.40625C8.28906 10.8203 8.25 11.6406 8.25 12.5C8.25 13.3984 8.28906 14.2188 8.40625 15ZM15.3203 8.75C15.125 7.69531 14.7734 6.79688 14.3828 6.01562C13.5625 4.33594 12.625 3.75 12 3.75C11.3359 3.75 10.3984 4.33594 9.57812 6.01562C9.1875 6.79688 8.83594 7.69531 8.64062 8.75H15.3203ZM16.8047 10C16.9219 10.8203 17 11.6406 17 12.5C17 13.3984 16.9219 14.2188 16.8047 15H20.3594C20.5938 14.2188 20.75 13.3984 20.75 12.5C20.75 11.6406 20.5938 10.8203 20.3594 10H16.8047ZM14.7734 4.21875C15.5938 5.3125 16.2578 6.91406 16.6094 8.75H19.8906C18.875 6.64062 17.0391 5 14.7734 4.21875ZM9.1875 4.21875C6.92188 5 5.08594 6.64062 4.07031 8.75H7.35156C7.70312 6.91406 8.36719 5.3125 9.1875 4.21875ZM3.25 12.5C3.25 13.3984 3.36719 14.2188 3.60156 15H7.15625C7.03906 14.2188 7 13.3984 7 12.5C7 11.6406 7.03906 10.8203 7.15625 10H3.60156C3.36719 10.8203 3.25 11.6406 3.25 12.5ZM19.8906 16.25H16.6094C16.2578 18.125 15.5938 19.6875 14.7734 20.8203C17.0391 20.0391 18.875 18.3984 19.8906 16.25ZM7.35156 16.25H4.07031C5.08594 18.3984 6.92188 20.0391 9.1875 20.8203C8.36719 19.6875 7.70312 18.125 7.35156 16.25Z"
              fill="black"
            />
          </svg>
          <div class="flex items-center space-x-3 py-4">
            <div
              :class="
                twJoin(
                  'cursor-pointer hover:opacity-50',
                  locale !== 'en' && 'text-typo-muted'
                )
              "
              @click="() => handleChangeLanguage('en')"
            >
              EN
            </div>
            <div class="h-4 w-[1px] bg-gray-20" />
            <div
              :class="
                twJoin(
                  'cursor-pointer hover:opacity-50',
                  locale !== 'th' && 'text-gray-20'
                )
              "
              @click="() => handleChangeLanguage('th')"
            >
              ไทย
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { find } from 'lodash-es'
import { twJoin } from 'tailwind-merge'

const userStore = useUserStore()
const { access_token } = storeToRefs(userStore)
const { locale, setLocale } = useI18n()

const appHeight = ref<number>(0)

const emit = defineEmits<{
  (e: 'close'): void
}>()

const props = defineProps<{
  menu?: {
    title: string
    titleMobile: string
    url: string
    blockItems?: {
      title: string
      items: {
        titleEn: string
        titleTh: string
        imageUrl: string
        descriptionEn: string
        descriptionTh: string
        buttonTitle: string
        buttonUrl: string
      }[]
    }
    list: {
      title: string
      linkItems: {
        title: string
        url: string
        footerTitle: string
        items: { title: string; url: string; imageUrl?: string }[]
      }[]
      cardItems: {
        title: string
        url?: string
        footerTitle?: string
        items: { title: string; url: string; imageUrl: string }[]
      }[]
    }[]
  }[]
}>()

const activeMenu = ref<null | string>(props.menu?.[0]?.title || null)
const activeList = ref<null | string>(null)
const activeSubList = ref<null | string>(null)

const activePage = computed(() =>
  find(props.menu, (list) => list.title == activeMenu.value)
)

const activeListPage = computed(() =>
  find(
    find(props.menu, (list) => list.title == activeMenu.value)?.list,
    (list) => list.title == activeList.value
  )
)

// const handleSetSubMenu = (title: string) => {
//   subMenu.value = title
// }

const handleChangeLanguage = (lang: string) => {
  setLocale(lang)
  emit('close')
}

const getAppHeight = () => {
  appHeight.value = window.innerHeight
}

onMounted(() => {
  let timer: NodeJS.Timeout
  getAppHeight()
  window?.addEventListener('resize', () => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      getAppHeight()
    }, 200)
  })
})

onUnmounted(() => {
  window?.removeEventListener('resize', getAppHeight)
})
</script>
